// extracted by mini-css-extract-plugin
export default {"root":"_1yFXr","dot":"_9-Pk1","current":"vxHur"};